export const techSpecsManualSwitcher = (): void => {
  /* Handle all individual "Tech Spec Switchers" HTML blocks inside the individual "Tech Spec" HTML block */
  const engageTechSpecsManulSwitchers = (techSpecBlock: Element) => {
    const techSpecContentWrappers = techSpecBlock.querySelectorAll('.js-techSpecs-contentWrapper')

    /* Individual contents */
    techSpecContentWrappers.forEach(techSpecContentWrapper => {
      const techSpecSwitchers = techSpecContentWrapper.querySelectorAll('.js-techSpecs-switcherButton')

      /* Individual button */
      techSpecSwitchers.forEach(techSpecSwitcher => {
        techSpecSwitcher.addEventListener('click', () => {
          if (techSpecSwitcher.classList.contains('js-techSpecs-switcherButton-active')) {
            return
          }

          const targetTechSpecKey = techSpecSwitcher.getAttribute('data-key')
          techSpecContentWrappers.forEach(techSpecContentWrapper_sub => {
            const localTechSpecKey = techSpecContentWrapper_sub.getAttribute('data-key')

            if (targetTechSpecKey === localTechSpecKey) {
              techSpecContentWrapper_sub.classList.add('-active')
            } else {
              techSpecContentWrapper_sub.classList.remove('-active')
            }
          })
        })
      })
    })
  }

  /* Handle all individual "Tech Spec" HTML blocks on the page */
  const allTechSpecBlocks = document.querySelectorAll('.js-techSpecs')
  allTechSpecBlocks.forEach(techSpecBlock => {
    engageTechSpecsManulSwitchers(techSpecBlock)
  })
}
